import { memo } from 'react';

type InlineErrorProps = {
  error: string | undefined;
  'data-testid'?: string;
};

export const InlineError = memo(({ error, 'data-testid': testId }: InlineErrorProps) => {
  if (!error) {
    return null;
  }

  return (
    <p
      className="absolute right-4 -bottom-1.5 ads:bg-base bg-gray-1 px-2 py-0.5 font-medium ads:text-error text-10 text-red-9"
      data-testid={testId}
    >
      {error}
    </p>
  );
});

InlineError.displayName = 'InlineError';
